import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CaretLeft, CaretRight, X, SignIn, SignOut } from "@phosphor-icons/react";

const ZONE_ICONS = { home: "🏠", school: "🎓", work: "💼", other: "📍" };
const dayIso = (d) => {
  const x = new Date(d);
  x.setMinutes(x.getMinutes() - x.getTimezoneOffset());
  return x.toISOString().slice(0, 10);
};

export default function GeofenceLog({ onClose }) {
  const [date, setDate] = useState(dayIso(new Date()));
  const [items, setItems] = useState(null);
  const [times, setTimes] = useState([]);

  useEffect(() => {
    setItems(null);
    setTimes([]);
    const from = new Date(`${date}T00:00:00`);
    const to = new Date(from.getTime() + 86400000);
    const q = `from=${from.toISOString()}&to=${to.toISOString()}`;
    api.get(`/geofences/log?${q}`)
      .then((r) => setItems(r.data.events))
      .catch(() => setItems([]));
    api.get(`/geofences/time?${q}`)
      .then((r) => setTimes(r.data.summary))
      .catch(() => {});
  }, [date]);

  const fmtDur = (s) => {
    const h = Math.floor(s / 3600);
    const m = Math.round((s % 3600) / 60);
    return h ? `${h} ч ${m ? `${m} м` : ""}`.trim() : `${m} мин`;
  };

  const shift = (delta) => {
    const d = new Date(`${date}T12:00:00`);
    d.setDate(d.getDate() + delta);
    setDate(dayIso(d));
  };

  const fmtTime = (iso) => new Date(iso).toLocaleTimeString("ru-RU", { hour: "2-digit", minute: "2-digit" });

  return (
    <div className="glass-card p-3" data-testid="geofence-log">
      <div className="flex items-center gap-2 flex-wrap mb-1">
        <span className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Лента зон</span>
        <div className="flex items-center gap-1 ml-1">
          <button onClick={() => shift(-1)} data-testid="zonelog-prev-day"
            className="p-1 rounded hover:bg-secondary transition-colors"><CaretLeft size={14} /></button>
          <span className="text-xs num">{new Date(date + "T12:00:00").toLocaleDateString("ru-RU", { weekday: "short", day: "numeric", month: "short" })}</span>
          <button onClick={() => shift(1)} disabled={date >= dayIso(new Date())} data-testid="zonelog-next-day"
            className="p-1 rounded hover:bg-secondary transition-colors disabled:opacity-30"><CaretRight size={14} /></button>
        </div>
        <button onClick={onClose} data-testid="zonelog-close" className="ml-auto p-1 rounded hover:bg-secondary transition-colors"><X size={15} /></button>
      </div>
      {times.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2" data-testid="zonelog-time-summary">
          {times.map((t, i) => (
            <span key={i} data-testid="zonelog-time-chip"
              className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ${t.inside_now
                ? "bg-emerald-500/15 text-emerald-300 ring-emerald-500/25"
                : "bg-secondary text-muted-foreground ring-white/[0.06]"}`}>
              {t.user_name} · {ZONE_ICONS[t.icon] || "📍"} {t.zone_name} — <b className="text-foreground num">{fmtDur(t.seconds)}</b>
              {t.inside_now && <span className="text-emerald-400"> · сейчас там</span>}
            </span>
          ))}
        </div>
      )}
      {items == null ? (
        <p className="text-xs text-muted-foreground py-2">Загружаем…</p>
      ) : items.length === 0 ? (
        <p className="text-xs text-muted-foreground py-2">За этот день событий не было — переходы появляются, когда кто-то из семьи входит в зону или покидает её.</p>
      ) : (
        <div className="max-h-56 overflow-y-auto pr-1" data-testid="zonelog-list">
          {items.map((e) => (
            <div key={e.id} className="flex items-center gap-2.5 py-1.5 border-b border-white/[0.05] last:border-0" data-testid="zonelog-item">
              <span className="text-[11px] text-muted-foreground num w-10 shrink-0">{fmtTime(e.at)}</span>
              {e.entered
                ? <SignIn size={15} weight="bold" className="text-emerald-400 shrink-0" />
                : <SignOut size={15} weight="bold" className="text-amber-400 shrink-0" />}
              <span className="text-sm min-w-0 truncate">
                <b>{e.user_name}</b> {e.entered ? "пришёл(ла) в" : "покинул(а)"} {ZONE_ICONS[e.icon] || "📍"} «{e.zone_name}»
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
